// Quiet-shell routes (REN-187 D29 R1/R4) — /i/:token and /l/:shareToken render
// their own minimal wordmark chrome (src/pages/i/[token].tsx, src/pages/l/[shareToken].tsx)
// and must not show the marketing nav/footer on top of it. Shared by
// Navigation.tsx and Footer.tsx so the route list only lives in one place.
export function isQuietShellRoute(pathname: string): boolean {
  return /^\/(i|l|w)(\/|$)/.test(pathname);
}
